<template>
  <div>
    <section class="flex flex-col w-full">
      <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
        {{ trans.get('string-items.lista') }}
      </h1>
      <div class="flex w-full p-4 justify-end">
        <div class="relative w-1/5">
          <select class="w-full block appearance-none bg-gray-100 border-b rounded-none border-gray-700 text-gray-700 px-4 py-2 pr-8"
                  v-model="itemsFilter"
                  @change="filter(true)"
          >
            <option value="" selected>{{ trans.get('items.filtro_tutti') }}</option>
            <option :value="material" v-for="material in materials"
                    v-text="material"></option>
          </select>
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
            </svg>
          </div>
        </div>
      </div>
    </section>

    <section class="w-3/4 table mx-auto rounded border shadow-lg">
      <div class="th tr">
        <div class="td">
          {{ trans.get('string-items.nota') }}
        </div>
        <div class="td">
          {{ trans.get('string-items.materiale') }}
        </div>
        <div class="td">
          {{ trans.get('string-items.specials') }}
        </div>
        <div class="td">
          {{ trans.get('string-items.famiglia') }}
        </div>
        <div class="td">
          {{ trans.get('string-items.codice-sfuso') }}
        </div>
        <div class="td">
          {{ trans.get('string-items.codice-imbustato') }}
        </div>
      </div>
      <section>
        <div class="row"
             v-for="code in codes"
             :key="code.id"
        >
          <div class="tr">
            <div class="td uppercase">
              <editable-cell-input :id="code.id"
                                   :data="code.note"
                                   :field="'note'"
                                   :url="url"
                                   @data-has-changed="onDataHasChanged"
              >
              </editable-cell-input>
            </div>
            <div class="td">
              <editable-cell-selector-v2 :id="code.id"
                                   :data="code.material"
                                   :field="'material'"
                                   :url="url"
                                   :dataset="materials"
                                   @data-has-changed="onDataHasChanged"
              >
              </editable-cell-selector-v2>
            </div>
            <div class="td uppercase">
              <editable-cell-input :id="code.id"
                                   :data="code.specials"
                                   :field="'specials'"
                                   :url="url"
                                   @data-has-changed="onDataHasChanged"
              >
              </editable-cell-input>
            </div>
            <div class="td">
              <editable-cell-selector-v2 :id="code.id"
                                         :data="code.family"
                                         :field="'family'"
                                         :url="url"
                                         :dataset="['lever', 'pedal']"
                                         @data-has-changed="onDataHasChanged"
              >
              </editable-cell-selector-v2>
            </div>
            <div class="td uppercase">
              <editable-cell-input :id="code.id"
                                   :data="code.bulk_code"
                                   :field="'bulk_code'"
                                   :url="url"
                                   @data-has-changed="onDataHasChanged"
              >
              </editable-cell-input>
            </div>
            <div class="td uppercase">
              <editable-cell-input :id="code.id"
                                   :data="code.package_code"
                                   :field="'package_code'"
                                   :url="url"
                                   @data-has-changed="onDataHasChanged"
              >
              </editable-cell-input>
            </div>
          </div>
        </div>
      </section>
      <div class="flex justify-center py-2 items-center">
        <paginate :pagination="pagination" @paginate="filter" :offset="4"></paginate>
      </div>
    </section>
  </div>
</template>

<script>

import EditableCellInput from "./EditableCellInput";
import EditableCellSelectorV2 from "./utilities/EditableCellSelectorV2";
import Paginate from "./utilities/Paginate";

export default {

  components: {
    EditableCellInput,
    EditableCellSelectorV2,
    Paginate
  },

  data() {
    return {
      codes: [],
      materials: [
        'gut','silkgut','nylon','wire','biocarbon','carbon','bionylon'
      ],
      itemsFilter: '',
      url: '/string-items/',
      pagination: {}
    }
  },

  created() {
    this.filter();
  },

  methods: {
    onDataHasChanged() {
      this.$toastr.s('Data has been updated!');
    },

    filter(changed = false) {

      let current_page;

      if (!changed) {
        current_page = this.pagination.current_page;
      }

      let pageNum = current_page ? current_page : 1;

      axios.get(`/string-items?material=${this.itemsFilter}&paginate=25&page=${pageNum}`)
          .then(({data}) => {
            this.codes = data.data.codes;
            this.pagination = data.data.pagination;
          });
    },
  }
}
</script>

<style scoped>

</style>